<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'webGraspManageFileSplit' }"><span v-if="$route.params.scrap_type == 1">网站</span>
        <span v-if="$route.params.scrap_type == 2">接口</span>文件拆分管理</el-breadcrumb-item>
      <el-breadcrumb-item>拆分设置</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      拆分设置
      <div class="title-btn">
        <el-button type="primary"
          @click="$router.push({ name: 'systemSetCaptureLog', query: { type: $route.query.function_name == '首页>网抓爬虫管理>接口文件拆分' ? 3 : 1 } })">操作日志</el-button>
        <el-button type="primary" @click="save(0)" :loading="saveLoading">保存</el-button>
      </div>
    </h1>
    <div class="view-content">
      <el-form ref="form" label-width="100px">
        <el-card class="box-card">
          <div class="card-content">
            <el-row>
              <el-col :span="24">
                <el-form-item label="插件编码" class="wipe-mb">
                  <span>{{ clientInfo.plugin_code }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="经销商编码" class="wipe-mb">
                  <span>{{ clientInfo.client_code }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="经销商名称" class="wipe-mb">
                  <span>{{ clientInfo.name }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-form>
      <p class="hint">注意：子公司名称会在表格的"上级供应商"一列内进行查找</p>
      <el-card class="box-card">
        <div class="card-content">
          <el-table :data="subsidiaryList" style="width: 100%">
            <el-table-column prop="subsidiary_code" label="子公司编码">
              <template slot-scope="scope">
                <el-input size="medium" v-model="scope.row.subsidiary_code"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="subsidiary_name" label="子公司名称">
              <template slot-scope="scope">
                <el-input 
                  size="medium" 
                  v-model="scope.row.subsidiary_name"
                  :class="{ 'duplicate-input': isDuplicate(scope.row) }"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="ys_code" label="映射编码"> </el-table-column>
            <el-table-column prop="ys_name" label="映射名称">
              <template slot-scope="scope">
                <span :class="{ 'duplicate-cell': isDuplicate(scope.row) }">
                  {{ scope.row.ys_name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="operate" width="120" label="操作">
              <template slot-scope="scope">
                <el-button @click.native.prevent="rowSelect(scope.$index, scope.row)" type="text" size="small">
                  选择
                </el-button>
                <el-button @click.native.prevent="deleteRow(scope.$index, scope.row)" type="text" size="small">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button @click="addRow" class="add-button" size="medium">新增</el-button>
        </div>
      </el-card>
    </div>
    <choose-dealer ref="chooseDealer" @saveChange="dealerSaveChange" :is-checkbox="false" :is-clear-search-text="true"
      :type="1"></choose-dealer>


    <el-dialog title="提示" :visible.sync="configmForce.visible" :width="'500px'">
      {{ configmForce.msg }}
      <span slot="footer" class="dialog-footer">
        <el-button @click="configmForce.visible = false">取 消</el-button>
        <el-button type="primary" @click="save(1)" :loading="configmForce.isLoading">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import { getSplitFileInfo, addSplitfile } from "@/api/index";
import ChooseDealer from "@/components/ChooseDealer";

export default {
  name: "SplitSet",
  components: {
    ChooseDealer
  },
  beforeCreate() {
    this.clientId = this.$route.params.id;
  },
  data: () => ({
    currentPage: 1,
    clientInfo: {},
    subsidiaryList: [],
    tableData: [],
    currentRowIndex: -1,
    configmForce: {
      visible: false,
      msg: "",
      isLoading: false
    },
    saveLoading: false
  }),
  created() {
    this._getInfo();
  },
  methods: {
    _getInfo() {
      getSplitFileInfo(this.clientId, this.$route.params.scrap_type).then(
        res => {
          if (0 === res.status) {
            this.clientInfo = res.data.client;
            this.subsidiaryList = res.data.subsidiary;
          }
        }
      );
    },
    rowSelect(index, row) {
      this.currentRowIndex = index;
      row.client_code = row.ys_code;
      this.$refs.chooseDealer.openDialog([row]);
    },
    deleteRow(index, row) {
      if (index !== -1) {
        this.subsidiaryList.splice(index, 1);
      }
    },
    addRow() {
      this.subsidiaryList.push({
        subsidiary_code: "",
        subsidiary_name: "",
        ys_code: "",
        ys_name: ""
      });
    },
    dealerSaveChange(selectionVal) {
      if (this.currentRowIndex !== -1) {
        this.subsidiaryList[this.currentRowIndex].ys_code =
          selectionVal[0].client_code;
        this.subsidiaryList[this.currentRowIndex].ys_name =
          selectionVal[0].name;
        this.subsidiaryList[this.currentRowIndex].ys_id =
          selectionVal[0].client_id;
      }
    },
    save(is_force_set = 0) {
      if (this.saveLoading) return;
      
      let client_id = this.clientInfo.client_id;
      let subsidiaryList = this.subsidiaryList;
      let subsidiary = [];

      // 检查重复数据
      const hasDuplicates = this.subsidiaryList.some(row => this.isDuplicate(row));
      if (hasDuplicates) {
        this.$message.error('列表存在重复数据，修改后再保存');
        return;
      }

      for (let item of subsidiaryList) {
        if (!item.subsidiary_name || item.subsidiary_name === "") {
          this.$message.error("请填写子公司名称");
          return;
        }
        if (!item.ys_id || item.ys_id === "") {
          this.$message.error("请选择映射公司");
          return;
        }
      }

      this.saveLoading = true;

      for (let item of subsidiaryList) {
        let obj = {
          subsidiary_code: item.subsidiary_code,
          subsidiary_name: item.subsidiary_name,
          ys_name: item.ys_name,
          ys_code: item.ys_code,

          parent_original_names: this.$route.query.parent_original_names
        };
        item.ys_id ? (obj.subsidiary_id = item.ys_id) : "";
        subsidiary.push(obj);
      }
      let parameter = {
        client_id,
        subsidiary,
        type: this.$route.params.scrap_type,
        is_force_set
      };
      if (this.$route.query.intro) {
        parameter.intro = this.$route.query.intro
      }
      if (this.$route.query.function_name) {
        parameter.function_name = this.$route.query.function_name
      }

      console.log(parameter);
      this.configmForce.isLoading = true;
      addSplitfile(parameter).then(res => {
        this.configmForce = {
          visible: false,
          msg: "",
          isLoading: false
        };
        this.saveLoading = false;
        if (0 === res.status) {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.$router.push({ name: "webGraspManageFileSplit" });
        } else if (res.status == 4) {
          this.configmForce = {
            visible: true,
            msg: res.msg,
            isLoading: false
          };
        } else {
          this.$message.error(res.msg);
        }
      }).catch(() => {
        this.saveLoading = false;
      });
    },
    isDuplicate(row) {
      return this.subsidiaryList.filter(
        item =>
          item.subsidiary_name === row.subsidiary_name &&
          item.ys_name === row.ys_name
      ).length > 1;
    }
  }
};
</script>

<style scoped lang="scss">
.hint {
  color: #a6a6a6;
  font-size: 14px;
  padding: 10px 35px;
}

.add-button {
  margin-top: 20px;
}

.duplicate-input {
  ::v-deep .el-input__inner {
    background-color: #fde2e2;
    border-color: #f56c6c;
  }
}

.duplicate-cell {
  display: block;
  padding: 0 15px;
  background-color: #fde2e2;
  color: #f56c6c;
  line-height: 32px;
}
</style>
